import styled from 'styled-components'
import { AMBER_400, LIGHT_YELLOW, MEDIUM_YELLOW } from '../../styles/colors'

export const Container = (styled.div as any)`
  border-color: ${MEDIUM_YELLOW};
  border-left-color: ${AMBER_400};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-style: solid;
  border-width: 1px;
  border-left-width: 5px;
  padding: 12px;
  background-color: ${LIGHT_YELLOW};
`
